import { Mes } from './mes';
import { Aquisicao } from '../../../../cliente-carteira/kpis/aquisicao/adapters';
import { CarteiraInativa } from '../../../../cliente-carteira/kpis/carteira-inativa/adapters';
import { Comissao } from '../../../../comissao/kpis/adapters';

/** Dados dos KPIs trimestral */
export class Trimestre {
    trimestre: number;
    meses: Mes[];
    aquisicao: Aquisicao;
    carteiraInativa: CarteiraInativa;
    comissao: Comissao;

    constructor(props: Partial<Trimestre>) {
        Object.assign(this, props);

        if (props) {
            // Meses
            this.constructorMeses(props.meses);
            // Aquisição
            this.aquisicao = props.aquisicao ? new Aquisicao(props.aquisicao) : null;
            // Carteira Inativa
            this.carteiraInativa = props.carteiraInativa ? new CarteiraInativa(props.carteiraInativa) : null;
            // Comissão
            this.comissao = props.comissao ? new Comissao(props.comissao) : null;
        }
    }

    /** Constructor para os meses */
    private constructorMeses(meses: Mes[]) {
        if (meses && Array.isArray(meses)) {
            this.meses = meses.map(mes => new Mes(mes));
        } else {
            this.meses = [];
        }
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): Trimestre {
        return new Trimestre(JSON.parse(json));
    }
}
